// Achata la respuesta cruda de ARCA (datosGenerales / datosRegimenGeneral /
// datosMonotributo) a la forma que consume el formulario.
//
// Es el port JS de arca_resumen() de api/afip/arca.php y de resumen() de
// afip-consulta/arca.py. Hace falta porque tusfacturas.app devuelve la
// constancia cruda en `constancia_full_datos`: pasandola por aca, las dos
// fuentes terminan en el mismo objeto y el resto del codigo no las distingue.

const lista = (valor) => {
  if (!valor) return [];
  return Array.isArray(valor) ? valor : [valor];
};

export const resumirConstanciaCruda = (persona) => {
  const gen = persona?.datosGenerales || {};
  const dom = gen.domicilioFiscal || {};
  const mono = persona?.datosMonotributo || {};
  const rg = persona?.datosRegimenGeneral || {};

  const razon =
    gen.razonSocial ||
    [gen.apellido, gen.nombre].filter(Boolean).join(" ") ||
    null;

  const partes = [
    dom.direccion,
    dom.localidad,
    dom.descripcionProvincia,
    dom.codPostal ? `CP ${dom.codPostal}` : null,
  ].filter(Boolean);

  const impuestos = [...lista(mono.impuesto), ...lista(rg.impuesto)];
  const actividades = [...lista(mono.actividad), ...lista(rg.actividad)];
  const catMono = mono.categoriaMonotributo || null;

  return {
    cuit: gen.idPersona ? String(gen.idPersona) : null,
    razon_social: razon,
    nombre: gen.nombre || null,
    apellido: gen.apellido || null,
    tipo_persona: gen.tipoPersona || null,
    tipo_clave: gen.tipoClave || null,
    estado_clave: gen.estadoClave || null,
    mes_cierre: gen.mesCierre || null,
    fecha_contrato_social: gen.fechaContratoSocial || null,
    dependencia: gen.dependencia?.descripcionDependencia || null,
    domicilio: {
      direccion: dom.direccion || null,
      localidad: dom.localidad || null,
      provincia: dom.descripcionProvincia || null,
      cod_postal: dom.codPostal ? String(dom.codPostal) : null,
      tipo: dom.tipoDomicilio || null,
      dato_adicional: dom.datoAdicional || null,
      completo: partes.length ? partes.join(", ") : null,
    },
    impuestos: impuestos.map((i) => ({
      id: i?.idImpuesto != null ? String(i.idImpuesto) : null,
      descripcion: i?.descripcionImpuesto || null,
      estado: i?.estadoImpuesto || null,
      periodo: i?.periodo || null,
    })),
    actividades: actividades.map((a) => ({
      id: a?.idActividad != null ? String(a.idActividad) : null,
      descripcion: a?.descripcionActividad || null,
      nomenclador: a?.nomenclador != null ? String(a.nomenclador) : null,
      orden: a?.orden != null ? String(a.orden) : null,
    })),
    monotributo: catMono
      ? {
          categoria: catMono.descripcionCategoria || null,
          id_categoria: catMono.idCategoria || null,
          periodo: catMono.periodo || null,
        }
      : null,
    categoria_autonomo: rg.categoriaAutonomo?.descripcionCategoria || null,
  };
};
